__webpack_require__.p = "/lyric-writing-assistant/";